import React, { useState, useEffect, useCallback } from 'react';
import { setLoader } from '../../../../../../redux/app/app.actions';
import { ucsfLoginInstance } from '../../../../../axios/ucsf';
import { COMPONENT_APIS } from '../../../../../utils/omi-api';
import { useDispatch } from 'react-redux';
import AppService from '../../../../../services/app-service';

const UserVerificationFlow = ({ onViewChange, urlParams = {} }) => {
  const dispatch = useDispatch();
  const [verificationStatus, setVerificationStatus] = useState(null);
  const [statusMessage, setStatusMessage] = useState('');

  const token = urlParams.token || '';

  const verifyEmail = useCallback(async () => {
    dispatch(setLoader(true, 'Verifying your email...'));
    try {
      await ucsfLoginInstance.post(COMPONENT_APIS.EMAIL_VERIFICATION, {
        token: token
      });
      setVerificationStatus('success');
      setStatusMessage('Your email has been verified successfully! You can now log in.');
      AppService.setNotification({
        title: 'Success!',
        message: 'Your email has been verified. You can now log in to your account.'
      });
      dispatch(setLoader(false));
    } catch (error) {
      setVerificationStatus('error');
      setStatusMessage(error.response?.data?.message || 'Email verification failed. Please try again.');
      dispatch(setLoader(false));
    }
  }, [token, dispatch]);

  useEffect(() => {
    if (token) {
      verifyEmail();
    }
  }, [token, verifyEmail]);

  return (
    <>
      <div className="auth-card-header">
        <h2 className="auth-card-title">
          {verificationStatus === 'success' ? 'Email Verified' : verificationStatus === 'error' ? 'Verification Failed' : 'Verifying Email'}
        </h2>
      </div>

      <div className={`auth-${verificationStatus === 'success' ? 'success' : 'error'}-message`}>
        {statusMessage}
      </div>

      <div className="auth-card-footer-links" style={{ marginTop: '1rem' }}>
        <button
          className="auth-card-link"
          onClick={() => onViewChange('login')}
        >
          Go to Login
        </button>
      </div>
    </>
  );
};

export default UserVerificationFlow;
